/* istanbul ignore file REMOVE THIS WHEN I18NPLACEHOLDERS ARE REMOVED */
import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/startAPetitionV2/start-a-petition.yml';

import { StartAPetition as StartAPetitionBase } from './entryPoint';

export const StartAPetition = withI18nPlaceholders(I18N_PLACEHOLDERS, StartAPetitionBase);
